import { computed, defineComponent, onMounted, ref } from "vue";
import gsap from "gsap";

interface DisplaytypeLine {
  text: string;
  maskHeight?: number;
  indent?: number;
}

export default defineComponent({
  props: {
    line1: { type: String, required: false },
    line1MaskHeight: { type: Number, default: 100 },
    line1Indent: { type: Number, default: 0 },
    line2: { type: String, required: false },
    line2MaskHeight: { type: Number, default: 100 },
    line2Indent: { type: Number, default: 0 },
    line3: { type: String, required: false },
    line3MaskHeight: { type: Number, default: 100 },
    line3Indent: { type: Number, default: 0 },
    line4: { type: String, required: false },
    line4MaskHeight: { type: Number, default: 100 },
    line4Indent: { type: Number, default: 0 },
    loadedInStorybook: { type: Boolean, default: false },
    animateTitle: { type: Boolean, default: false },
    elementType: { type: String, default: "h1" },
  },
  setup(props) {
    const titleElement = ref<HTMLElement | null>(null);
    const lines = computed(() => {
      const lineArray = [] as DisplaytypeLine[];

      if (props.line1) {
        lineArray.push({
          text: props.line1,
          maskHeight: props.line1MaskHeight,
          indent: props.line1Indent,
        });
      }

      if (props.line2) {
        lineArray.push({
          text: props.line2,
          maskHeight: props.line2MaskHeight,
          indent: props.line2Indent,
        });
      }

      if (props.line3) {
        lineArray.push({
          text: props.line3,
          maskHeight: props.line3MaskHeight,
          indent: props.line3Indent,
        });
      }

      if (props.line4) {
        lineArray.push({
          text: props.line4,
          maskHeight: props.line4MaskHeight,
          indent: props.line4Indent,
        });
      }

      return lineArray;
    });

    onMounted(() => {
      if (props.animateTitle) {
        gsap.from(titleElement.value!.querySelectorAll(".nmm_title__line"), {
          yPercent: 100,
          delay: 0.5,
          stagger: { amount: 0.25 },
        });
      }
    });

    return { lines, titleElement };
  },
});
